import { render, staticRenderFns } from "./AnexoReclamacion.vue?vue&type=template&id=2b596308&"
import script from "./AnexoReclamacion.vue?vue&type=script&lang=js&"
export * from "./AnexoReclamacion.vue?vue&type=script&lang=js&"
import style0 from "./AnexoReclamacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports